import React, { useState } from 'react';
import styled from 'styled-components';
import defaultRecipeImageBase64 from '../assets/images/default-recipe.js';

/**
 * Composant pour afficher les images de recettes avec gestion des erreurs
 * et support des images locales ou distantes.
 */
const RecipeImage = ({ src, alt, className }) => {
  const [imageError, setImageError] = useState(false);
  
  // Déterminer la source de l'image
  const getImageSource = (src) => {
    // Si l'URL est déjà une URL absolue (http ou https)
    if (src && (src.startsWith('http://') || src.startsWith('https://'))) {
      return src;
    }
    
    // Si c'est un chemin local commençant par /assets
    if (src && src.startsWith('/assets/')) {
      // Enlever le slash au début pour l'import relatif
      return process.env.PUBLIC_URL + src;
    }
    
    // En cas d'erreur ou si la source est vide
    return defaultRecipeImageBase64;
  };
  
  const handleImageError = () => {
    console.warn(`Impossible de charger l'image: ${src}`);
    setImageError(true);
  };
  
  return (
    <StyledImageContainer>
      <StyledImage 
        src={imageError ? defaultRecipeImageBase64 : getImageSource(src)} 
        alt={alt || 'Recette Tartina'} 
        onError={handleImageError}
        className={className}
      />
    </StyledImageContainer>
  );
};

const StyledImageContainer = styled.div`
  position: relative;
  overflow: hidden;
  height: 180px;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: ${({ theme }) => theme.colors.secondary};
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
`;

export default RecipeImage;
